export default __webpack_public_path__ + "static/media/carShop.31ed576e.JPG";